import injectionHelpers from '@carwow/injection-rules-helpers';

import config from '@carwow/injection-default-config';

const desktopInlineAndSideAds = {
  id: 'inline-and-side',
  componentType: 'desktopSideAndInlineAd',
  condition: (options) => injectionHelpers.shouldInjectInlineAndSideAds(options),
  component: ({
    componentCount: adCount, localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'inline-and-side',
    props: adCount,
    defaultConfig: config.getDesktopAdsConfig(adCount),
  }),
  resetCurrentItemTypeCurrentCounter: true,
};

const desktopFirstSideAd = {
  id: 'first-side',
  componentType: 'desktopSideAndInlineAd',
  condition: (options) => injectionHelpers.shouldInjectFirstSideAd(options),
  component: ({
    componentCount: adCount, localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'first-side',
    props: adCount,
    defaultConfig: config.getSideAdConfig(adCount),
  }),
};

const injectFinalSideAd = {
  id: 'final-side',
  componentType: 'desktopSideAndInlineAd',
  condition: (options) => injectionHelpers.shouldInjectFinalSideAd(options),
  component: ({
    componentCount: adCount, localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'final-side',
    props: adCount,
    defaultConfig: config.getSideAdConfig(adCount),
  }),
  resetCurrentItemTypeCurrentCounter: true,
};

export default [
  desktopInlineAndSideAds,
  desktopFirstSideAd,
  injectFinalSideAd,
];
